export default function ProcessController(
  $q,
  $filter,
  $scope,
  $rootScope,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  emDataService,
  emSharedModelService,
  confirmDialog,
  editProcessDialog,
  editFunctionDialog
) {
  const vm = this;

  vm.handleExpandProcess = _handleExpandProcess;
  vm.handleAddFunction = _handleAddFunction;
  vm.handleEditProcess = _handleEditProcess;
  vm.handleDeleteProcess = _handleDeleteProcess;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.isExpanded = false;

  _activate();


  /** *************************************************
   * Event Handlers
   */

  function _handleExpandProcess() {
    if (vm.process.functions.length > 0 && !vm.isEdit) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleAddFunction($event) {
    loaderService.showViewLoader = true;
    emSharedModelService.createNewFunction(vm.process.processId)
      .then((newFunctionObj) => {
        loaderService.showViewLoader = false;
        _showEditFunctionDialog($event, newFunctionObj);
      });
  }

  function _handleEditProcess($event) {
    loaderService.showViewLoader = true;
    emDataService.getProcess(vm.process.processId).then((getProcessResponse) => {
      try {
        _showEditProcessDialog($event, getProcessResponse);
      } catch (error) {
        console.error(error);
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleDeleteProcess($event) {
    _showDeleteProcessConfirmDialog($event);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return emDataService.deleteProcess(vm.process.processId)
      .then(() => {
        alerts.success('The process has been deleted successfully.');
        $rootScope.$broadcast('refreshDepartments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the process.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on(
      'expandProcess',
      ($event, expandProcessArgs) => {
        if (
          vm.process.processId === expandProcessArgs.processId
          && (vm.process.functions && vm.process.functions.length > 0)
          && !vm.isEdit
        ) {
          vm.isExpanded = true;
        }
      }
    );
    $scope.$on(
      'collapseProcess',
      ($event, expandProcessArgs) => {
        if (
          vm.process.processId === expandProcessArgs.processId         
        ) {
          vm.isExpanded = false;
        }
      }
    );
   
    $scope.$emit('processDirectiveEventsSet');
  }

  function _showEditProcessDialog($event, getProcessResponse) {
    emDataService.getSuccessorOptions(vm.process.processId).then((response) => {
      ssDialogService.dialogs.enterpriseModeling.editProcessDialog = ssDialogService.alert(
        editProcessDialog.getOptions($event, {
          customerId: vm.customerId,
          department: vm.department,
          process: getProcessResponse.data,
          isIt: vm.isIt,
          successorOptions: response
        })
      );
      ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProcessDialog);
    });
  }

  function _showDeleteProcessConfirmDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.deleteProcessConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Process?',
        message: `Are you sure you want to delete process "${vm.process.name}"?`,
        handleYesClick: vm.handleConfirmDelete,
        handleNoClick: vm.handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.deleteProcessConfirmDialog);
  }

  function _showEditFunctionDialog($event, functionObj) {
    ssDialogService.dialogs.enterpriseModeling.editFunctionDialog = ssDialogService.alert(
      editFunctionDialog.getOptions($event, {
        customerId: vm.customerId,
        department: vm.department,
        process: vm.process,
        functionObj,
        addCallback: _handleAddedFunction,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editFunctionDialog);
  }

  function _handleAddedFunction(functionObj, processDeptChanged) {
    if(processDeptChanged){
      _broadcastMoveChanges(functionObj)
    } else {
      vm.process.functions = vm.process.functions || [];
      vm.process.functions.push(functionObj);
      if (vm.process.functions.length > 1) {
        vm.process.functions = emSharedModelService.sortByName(vm.process.functions);
      }

      vm.process.functions.forEach((item) => {
        _filterFunctionDetails(item);
        _setMissingPermissions(item);
      });
    }    
  }

  function _filterFunctionDetails(functionObj) {
    functionObj.functionITAssets = _filterOptions(functionObj.functionITAssetTypes);
    functionObj.functionNonITAssets = _filterOptions(functionObj.functionNonITAssetTypes);
    functionObj.functionVendors = _filterOptions(functionObj.functionVendors);

    functionObj.functionVendors.forEach((item) => {
      item.functionProducts = _filterOptions(item.functionProducts);
    });

    functionObj.vendorCount = functionObj.functionVendors.length;

    let fitaCount = 0;
    let fnitaCount = 0;

    if (functionObj.functionITAssets !== undefined) {
      fitaCount = functionObj.functionITAssets.length;
    }

    if (functionObj.functionNonITAssets !== undefined) {
      fnitaCount = functionObj.functionNonITAssets.length;
    }

    functionObj.assetCount = fitaCount + fnitaCount;
  }

  function _filterOptions(options) {
    return $filter('filter')(options, { isSelected: true, });
  }

  function _setMissingPermissions(functionObj) {
    // Set missing permissions
    if ((functionObj.canDelete === null) || (functionObj.canDelete === undefined)) {
      functionObj.canDelete = functionObj.canDeleteFunction;
    }
    if ((functionObj.canEdit === null) || (functionObj.canEdit === undefined)) {
      functionObj.canEdit = functionObj.canEditFunction;
    }
  }

  function _broadcastMoveChanges(functionObj) {
    $rootScope.$broadcast('moveDepartmentRefresh', { departmentId: functionObj.departmentId, processId: functionObj.processId });
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.deleteProcessConfirmDialog);
  }
}

ProcessController.$inject = [
  '$q',
  '$filter',
  '$scope',
  '$rootScope',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'emDataService',
  'emSharedModelService',
  'confirmDialog',
  'editProcessDialog',
  'editFunctionDialog'
];
